import Vue from "vue";
import HealthCheck from "./HealthCheck.vue";
import store from "./store";
import VueScrollTo from "vue-scrollto";
import VueRecaptcha from "vue-recaptcha";

Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
  duration: 500,
  container: "#health_check__container"
});

Vue.component("vue-recaptcha", VueRecaptcha);

new Vue({
  store,
  render: h => h(HealthCheck)
}).$mount("#health_check");
